<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    width: {
        type: String,
        default: '30rem'
    },
    height: {
        type: String,
        default: '45rem'
    }
});

const emit = defineEmits(['close']);

const panel = ref(null);
let offsetX = 0;
let offsetY = 0;
let isDragging = false;

const onMouseDown = (event) => {
    offsetX = event.clientX - panel.value.offsetLeft;
    offsetY = event.clientY - panel.value.offsetTop;
    isDragging = true;
};

const onMouseMove = (event) => {
    if (isDragging) {
        panel.value.style.left = `${event.clientX - offsetX}px`;
        panel.value.style.top = `${event.clientY - offsetY}px`;
    }
};

const onMouseUp = () => {
    isDragging = false;
};

// 이벤트 리스너를 설정하고 제거합니다.
onMounted(() => {
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
});

onUnmounted(() => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
});
</script>

<template>
    <div class="default-panel-popup" :style="{ width: width, height: height }" ref="panel">
        <div class="default-panel-header" @mousedown="onMouseDown">
            <h2>{{ title }}</h2>
            <button class="close-button" @click="$emit('close')">
                <i class="pi pi-times"></i>
            </button>

            <!-- <button @click="$emit('close')" class="default-panel-close-button">닫기</button> -->
        </div>
        <div class="default-panel-content">
            <!-- 부모 컴포넌트에서 컴포넌트 슬롯을 통해 내용을 전달 받음 -->
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>
.default-panel-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 1.8rem;
    z-index: 400;
    overflow-y: auto;
}

.default-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    cursor: move;
    border-bottom: 0.1rem solid #ddd;
    padding-bottom: 0.8rem;
    font-size: 1.3rem;
    font-weight: bold;
}

.close-button {
    font-size: 1.1rem;
    font-family: 'SCoreDream300';
    color: #b7b9bd;
    cursor: pointer;
    background: none; /* Remove background */
    border: none; /* Remove border */
    padding: 0;
    line-height: 1; /* Align text vertically */
}

.close-button:hover {
    color: #000; /* Slightly darker on hover */
}
</style>
